var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAccountingInvoiceHand = function SvgAccountingInvoiceHand(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5349 23.86C16.0759 24.5716 16.7807 25.142 17.5894 25.5229C18.3981 25.9037 19.2868 26.0837 20.1799 26.0475C23.0274 26.0475 25.3374 24.315 25.3374 22.18C25.3374 20.045 23.0274 18.315 20.1799 18.315C17.3324 18.315 15.0249 16.5825 15.0249 14.445C15.0249 12.3075 17.3349 10.5775 20.1799 10.5775C21.073 10.5413 21.9617 10.7213 22.7704 11.1021C23.5791 11.4829 24.2839 12.0534 24.8249 12.765",
    stroke: "#8ADBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1802 26.0475V28.625",
    stroke: "#8ADBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1802 8V10.5775",
    stroke: "#8ADBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1249 52.965L54.3999 47.375V34.25C54.3999 29.25 44.8999 23.9025 41.2749 21.125",
    stroke: "#8ADBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0997 37.4849L36.9797 30.1749C36.3687 29.564 35.54 29.2207 34.676 29.2207C33.8119 29.2207 32.9832 29.564 32.3722 30.1749C31.7612 30.7859 31.418 31.6146 31.418 32.4787C31.418 33.3428 31.7612 34.1715 32.3722 34.7824L41.2047 44.75V51C41.2047 53.9525 45.4247 58.6125 45.4247 58.6125",
    stroke: "#8ADBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7749 58.625H5.3349C4.42365 58.6243 3.54995 58.2619 2.90584 57.6173C2.26172 56.9727 1.8999 56.0987 1.8999 55.1875V5.8125C1.8999 4.90125 2.26172 4.02729 2.90584 3.3827C3.54995 2.73812 4.42365 2.37566 5.3349 2.375H37.8349C38.7468 2.375 39.6214 2.73708 40.2665 3.38167C40.9115 4.02625 41.2742 4.90059 41.2749 5.8125V33.6175",
    stroke: "#8ADBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2749 36.125H11.2749C10.7776 36.125 10.3007 36.3225 9.94908 36.6742C9.59745 37.0258 9.3999 37.5027 9.3999 38V49.25C9.3999 49.7473 9.59745 50.2242 9.94908 50.5758C10.3007 50.9275 10.7776 51.125 11.2749 51.125H33.7749",
    stroke: "#8ADBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3999 43.625H30.0249",
    stroke: "#8ADBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6499 36.125V51.125",
    stroke: "#8ADBFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountingInvoiceHand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accounting-invoice-hand.c6d55978.svg";
export { ForwardRef as ReactComponent };